import { useCallback } from 'react';

import { ReactComponent as WarningIcon } from 'utils/assets/images/warningIconBlack.svg';
import { ReactComponent as CloseIcon } from 'utils/assets/images/xCloseIconWhite.svg';

import { useCropImageContext } from '../useCropImageContext/useCropImageContext';
import {
  ERROR_MSG_DESC,
  ERROR_MSG_TITLE,
  WARNING_MSG_DESC,
  WARNING_MSG_TITLE,
} from '../utils/constants';

import styles from './CropStateMessage.module.scss';

export const CropStateMessage = () => {
  const { isErrorSaving } = useCropImageContext();

  const getModalInfo = useCallback(() => {
    if (isErrorSaving) {
      return {
        icon: <WarningIcon />,
        iconClass: styles['crop-state__icon--error'],
        title: ERROR_MSG_TITLE,
        desc: ERROR_MSG_DESC,
      };
    }

    return {
      icon: <CloseIcon />,
      iconClass: styles['crop-state__icon--warning'],
      title: WARNING_MSG_TITLE,
      desc: WARNING_MSG_DESC,
    };
  }, [isErrorSaving]);

  return (
    <div className={styles['crop-state']}>
      <div className={`${styles['crop-state__icon']} ${getModalInfo().iconClass}`}>
        {getModalInfo().icon}
      </div>
      <h3 className={styles['crop-state__title']}>{getModalInfo().title}</h3>
      <div className={styles['crop-state__description']}>
        {getModalInfo().desc.map((paragraph, i) => (
          <p key={'message-' + i} className={styles['crop-state__description__item']}>
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};
